import { render, staticRenderFns } from "./exam.vue?vue&type=template&id=6fab6f88&scoped=true&"
import script from "./exam.vue?vue&type=script&lang=js&"
export * from "./exam.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/exam.scss?vue&type=style&index=0&id=6fab6f88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fab6f88",
  null
  
)

export default component.exports